// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1Oc-M","rootCenter":"LoadMoreObserver_rootCenter__2eeBZ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2aIdq"};